import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {Avatar, RemoveIcon} from 'rambler-ui'
import {getRamblerIdHelper} from '@rambler-id/helper'
import InternalHeader from 'components/InternalHeader'
import ProfileSection from 'components/ProfileSection'
import ProfileItem from 'components/ProfileItem'
import OauthButtons from 'components/OauthButtons'
import RowButton from 'components/RowButton'
import SocialIcon from 'components/icons/SocialIcon'
import {showSnackbar} from 'containers/App/actions'
import DetachSocial from '../DetachSocial'
import styles from './styles.css'

class Social extends PureComponent {
  static propTypes = {
    socialProfiles: PropTypes.array,
    championat: PropTypes.array,
    defaultChampionat: PropTypes.string,
    openPopup: PropTypes.func.isRequired,
    attachSocial: PropTypes.func.isRequired,
    detachSocial: PropTypes.func.isRequired
  }

  async componentDidMount() {
    const {attachSocial} = this.props
    const ramblerIdHelper = await getRamblerIdHelper()

    ramblerIdHelper.addListener(ramblerIdHelper.Events.OAUTHLOGIN, attachSocial)
  }

  async componentWillUnmount() {
    const {attachSocial} = this.props
    const ramblerIdHelper = await getRamblerIdHelper()

    ramblerIdHelper.removeListener(
      ramblerIdHelper.Events.OAUTHLOGIN,
      attachSocial
    )
  }

  detachSocial = async ({id, oauthAvatar, provider, displayName}) => {
    const {openPopup, detachSocial} = this.props

    try {
      await openPopup((onResolve, onReject) => (
        <DetachSocial
          id={id}
          oauthAvatar={oauthAvatar}
          provider={provider}
          displayName={displayName}
          onResolve={onResolve}
          onReject={onReject}
        />
      )).closed

      detachSocial(id, provider)
    } catch (error) {} // eslint-disable-line no-empty
  }

  render() {
    const {
      isPrimaryMailBlocked,
      showBlockedEmailSnackbar,
      socialProfiles,
      championat,
      defaultChampionat,
      info
    } = this.props

    const hasSberbankProfile = info.socialProfiles.some(
      ({provider}) => provider === 'sberbank'
    )

    return (
      <ProfileSection section="social" color="#f44336" icon={<SocialIcon />}>
        <InternalHeader>
          <h2>Вход по Сбер ID</h2>
          <p>
            Сбер ID — это наиболее безопасный способ входа в ваш профиль
            Rambler&Co по номеру телефона. Привяжите свой Сбер ID, чтобы входить
            в профиль с помощью одноразовых кодов из SMS.
          </p>
        </InternalHeader>
        <OauthButtons
          action="attach"
          scrollable={false}
          filter={(provider) => provider === 'sberbank' && !hasSberbankProfile}
          className={styles.oauthButtons}
          isPrimaryMailBlocked={isPrimaryMailBlocked}
          showBlockedEmailSnackbar={showBlockedEmailSnackbar}
          cerberId={(target) => `profile::social_provider::${target}`}
        />
        {socialProfiles.map((profile) => (
          <ProfileItem
            key={profile.id}
            leftIcon={
              <Avatar
                className={styles.avatar}
                src={profile.oauthAvatar}
                profileType={
                  profile.provider.startsWith('sberbank')
                    ? 'sberbank'
                    : profile.provider
                }
              />
            }
            rightIcon={
              profile.provider.startsWith('sberbank') ? null : (
                <RowButton
                  label="Удалить социальный аккаунт"
                  onClick={() => this.detachSocial(profile)}
                  data-cerber-id="profile::social_provider::delete_provider">
                  <RemoveIcon />
                </RowButton>
              )
            }>
            {profile.displayName}
          </ProfileItem>
        ))}
        {championat.map(({accountId}) => (
          <ProfileItem
            key={accountId}
            muted={accountId !== defaultChampionat}
            leftIcon={
              <Avatar
                className={styles.avatar}
                src="//avatars.rambler.ru/100x100/default"
                profileType="championat"
              />
            }>
            {accountId}
          </ProfileItem>
        ))}
      </ProfileSection>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  showBlockedEmailSnackbar: () => {
    dispatch(
      showSnackbar(
        'Вход в ваш профиль с помощью электронной почты заблокирован. Вам необходимо сменить пароль. Для восстановления доступа выйдите из профиля и войдите в него, указав в качестве логина свою почту',
        {type: 'main', autoCloseDuration: 10000}
      )
    )
  }
})

const withConnect = connect(null, mapDispatchToProps)

export default withConnect(Social)
